<template>
  <div>
    <h1 class="title">Ultimissima cosa!</h1>

    <!-- <p class="subtitle">
      <strong>Questo è l'ultimo step</strong>: la pappa è quasi pronta!
    </p> -->

    <form class="form max-w-5xl mx-auto mt-4" @submit.prevent>
      <div class="form-group">
        <label class="form-label important-label">
          Preferisci due buste indipendenti o una busta unica?
        </label>

        <p class="subtitle">
          Decidi come dividiere la sua pappa giornaliera in base alle tue preferenze e
          <strong>ricevi in omaggio la mitica PocketBowl!</strong>
        </p>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
          <label
            for="duplex_no"
            class="p-4 rounded-xl border-2 border-solid border-gray-300"
            :class="[dog.isDuplex == 0 ? 'big-active-option' : 'big-inactive-option']"
          >
            <input
              v-model.number="$v.dog.isDuplex.$model"
              class="hidden"
              type="radio"
              id="duplex_no"
              value="0"
            />
            <div class="w-32 h-32 mx-auto overflow-hidden">
              <img
                class="object-contain w-full h-full"
                :src="getImageUrl('questionario_bustasingola.jpg')"
                alt=""
              />
            </div>
            <div class="option-btn rb-subtitle-font">Una busta</div>
          </label>

          <label
            for="duplex_yes"
            class="p-4 rounded-xl border-2 border-solid border-gray-300"
            :class="[dog.isDuplex == 1 ? 'big-active-option' : 'big-inactive-option']"
          >
            <input
              v-model.number="$v.dog.isDuplex.$model"
              class="hidden"
              type="radio"
              id="duplex_yes"
              value="1"
            />
            <div class="w-32 h-32 mx-auto overflow-hidden">
              <img
                class="transform rotate-90 object-contain w-full h-full"
                :src="getImageUrl('questionario_bustadoppia.jpg')"
                alt=""
              />
            </div>
            <div class="option-btn rb-subtitle-font">Due buste indipendenti</div>
          </label>
        </div>

        <div v-if="$v.dog.isDuplex.$error" class="error">campo obbligatorio</div>
        <div v-if="dog.isDuplex == 0" class="additional-info">
          Una singola busta, scelta più ecologica, da riporre tra un pasto e l'altro della
          stessa giornata all'interno della mitica pocketbowl... in omaggio per te!
        </div>
        <div v-else class="additional-info">
          Un pò più oneroso, due buste separate, una per ogni pasto.
        </div>
      </div>

      <a
        class="underline inline-block text-sm italic py-2 cursor-pointer"
        v-on:click.stop="openModal()"
        >Maggiori info</a
      >
      <VideoPopup
        ref="videopopup"
        :intervalTime="10"
        :videoDesktopUrl="videoDesktopUrl"
        :videoMobileUrl="videoMobileUrl"
      >
      </VideoPopup>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import camelcaseKeys from "camelcase-keys";
import snakecaseKeys from "snakecase-keys";
import VideoPopup from "./VideoPopup.vue";

export default {
  components: {
    VideoPopup,
  },
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      videoDesktopUrl: "https://player.vimeo.com/video/783365328?h=1d0173308a",
      videoMobileUrl: "https://player.vimeo.com/video/783363452?h=2d295056f0",
      prices: [],
      dog: {
        isDuplex: null,
      },
    };
  },
  validations: {
    dog: {
      isDuplex: {
        required,
      },
    },
  },
  watch: {
    dog: {
      deep: true,
      handler: "getPrices",
    },
  },
  computed: {
    showNumberOfDogs() {
      return this.wizardData.numberOfDogs > 1 && this.wizardData.sameDiet;
    },
  },
  methods: {
    getUrl(value) {
      return this.$hostname + "/" + value;
    },
    getImageUrl(value) {
      return this.getUrl("wp-content/uploads/2022/12/" + value);
    },
    openModal() {
      this.$refs.videopopup.openModal();
    },
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        if (!this.$v.$invalid) {
          resolve({
            dog: {
              isDuplex: this.dog.isDuplex,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
    getAllergyIds() {
      let allergyIds = [];
      this.wizardData.dogs.map(function (dog) {
        allergyIds.push(dog["allergyIds"]);
      });
      return allergyIds.join();
    },
    async getPrices() {
      this.$emit("barAsyncState", "pending");
      var updatedData = [];
      var dog = [];
      updatedData = Object.assign({}, this.wizardData);

      // get prices to only one dog if different diet
      // otherwise get prices to all
      if (this.wizardData.numberOfDogs >= 2 && !this.wizardData.sameDiet) {
        updatedData.numberOfDogs = 1;
        updatedData.dogs = [];
        dog = Object.assign(this.dogData, this.dog);
        updatedData.dogs.push(dog);
      } else if (this.wizardData.numberOfDogs >= 2 && this.wizardData.sameDiet) {
        // first needs to update all dogs with isDuplex:
        for (let i = 0; i < this.wizardData.numberOfDogs; i++) {
          Object.assign(updatedData.dogs[i], this.dog);
        }
      } else {
        Object.assign(updatedData.dogs[updatedData.indexDog], this.dog);
      }

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          snakecaseKeys({
            form: updatedData,
            selectedRecipeId: this.dogData.recipeId,
          })
        ),
      };
      let url = this.$restAPIurlRB + "recipe-prices";
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      var camelcaseData = camelcaseKeys(data, { deep: true });
      this.prices = camelcaseData.recipes;

      this.$emit("prices", this.prices);
      this.$emit("barAsyncState", "success");
    },
  },
  activated() {
    this.dog.isDuplex = this.dogData.isDuplex;
    this.$v.$reset();
    this.getPrices();
  },
  mounted() {
    this.getPrices();
  },
};
</script>
